import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {Row, Col, Button, Tab} from "react-bootstrap";
import {FaPlus, FaArrowLeft, FaTrash} from "react-icons/fa";
import swal from 'sweetalert';
import Loader from "./LoaderModal";
import Side from "./Sidebar";
import Top from "./Topbar";
import {Pagination, TableHeader, TableBody, Filter, useDatatableLifecycle, shouldTableUpdate} from 'react-bs-datatable';
import C from '../lib/Config';

const CustomTable = React.memo(props => {
    const { data, tableHeaders, onChangeFilter, onPageNavigate, classes, onSortChange, tableClass, labels, filterable, filterText, rowsPerPage, currentPage, sortedProp, maxPage, Components } = useDatatableLifecycle(props);
    return (
      <div>
        <Components.Row className="controlRow__root">
          <Components.Col xs="12">
            <Filter
              classes={classes}
              tableHeaders={tableHeaders}
              placeholder='Search by Medicine Name'
              onChangeFilter={onChangeFilter}
              filterText={filterText}
              filterable={filterable}
            />
          </Components.Col>
        </Components.Row>
        <Components.Row>
          <Components.Col xs="12">
            <Components.Table className={tableClass}>
              <TableHeader
                classes={classes}
                tableHeaders={tableHeaders}
                sortedProp={sortedProp}
                onSortChange={onSortChange}
                components={{
                  TableHead: Components.TableHead,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
              <TableBody
                classes={classes}
                tableHeaders={tableHeaders}
                labels={labels}
                data={data}
                components={{
                  TableBody: Components.TableBody,
                  TableCell: Components.TableCell,
                  TableRow: Components.TableRow
                }}
              />
            </Components.Table>
          </Components.Col>
        </Components.Row>
        <Components.Row className="controlRow__root bottom">
          <Components.Col xs={12} md={12} className="text-right">
            <Pagination
              classes={classes}
              data={data}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              onPageNavigate={onPageNavigate}
              labels={labels}
              maxPage={maxPage}
              components={{ Button: Components.Button, ButtonGroup: Components.ButtonGroup }}
            />
          </Components.Col>
        </Components.Row>
      </div>
    );
  }, shouldTableUpdate);
export default class MedicineMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            medicineData: []
        };
       this.getAllMedicines = this.getAllMedicines.bind(this);
    }

    componentDidMount() {
        this.setState({ loaderModal: true })
        setTimeout(() => {
            this.getAllMedicines();
            this.setState({ loaderModal: false })
        }, 5000)
    }
    getAllMedicines() {
        return fetch(C.getUrl() + '/medicineMst/allMedicine', {
            method: 'GET',
            mode: 'cors',
        })
        .then(res => res.json())
        .then(res => {
            let resObj = res;
            let error = resObj.subErrors;
            if (error !== 'undefined' && error !== null && error !== "") {
                alert(error);
            } else {
                let obj = resObj.message;
            if (obj === 'No record found.') {
              
            } else {
                this.setState({ data: JSON.parse(resObj.message)})
                console.log(obj);
                  let tempData = JSON.parse(resObj.message);
                  let medicineData = [];
                  let index = 1;
                  tempData.forEach(obj => {
                      let data = {
                        id : index,
                        name : <Link to={{ pathname: '/AddMedicine', search: 'p=' + obj.longValue1 }}> {obj.stringValue1} </Link>,
                        desc : obj.stringValue2,
                        button : <FaTrash title="Delete Protocol" style={{color: "indianred"}} className="side-menu" onClick={() => this.deleteMedicine(obj.longValue1)}/>
                      }
                      medicineData.push(data);
                      index++;
                  }); 
                  this.setState({ medicineData: medicineData }); 
              }
            }
        })
        .catch(err => {
            console.log("Error : " + err);
        });
    }

    deleteMedicine(medicineId) {
      console.log("medicineId : "+medicineId);
       swal({
         title: 'Are you sure?',
         text: "Once deleted you will not be able to recover this medicine.",
         type: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#d33',
         confirmButtonText: "Yes",
         closeOnConfirm: false,
         buttons: true,
         buttons: ["No", "Yes"]
       }).then((isConfirm) => {
           if (isConfirm) {
              let loggedInuser = localStorage.getItem("userId");
              return fetch(C.getUrl() + '/medicineMst/inactivateMedicine?medicineId='+medicineId+'&updatedById='+ loggedInuser , {
                  method: 'GET',
                  mode: 'cors',
              })
              .then(res => res.json())
              .then(res => {
                  let resObj = res;
                  let error = resObj.subErrors;
                  if (error !== 'undefined' && error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                  } else {
                      let obj = resObj.message;
                      if (resObj.statusCode == 200) {
                          this.setState({ saveLoader: true });
                          setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                          swal({ title: obj, icon: "success", buttons: false, timer: 10000, });
                          window.location.reload();
                      } else { 
                        setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                        swal({ title: obj, icon: "success", buttons: false, timer: 10000, });
                      }
                  }
              })
              .catch(err => {
                  console.log("Error : " + err);
              });
           }
       });
     }

    render() {
        const header = [{title: '#', prop: 'id'},{title: 'Medicine Name', prop: 'name', sortable: true, filterable: true},{title: 'Description', prop: 'desc', sortable: true}
        ,{title: 'Action', prop: 'button'}];
        const customLabels = {show: 'Display', entries: 'rows', noResults: 'No records found'};
        const classes = {table: 'table-striped table-striped table-hover text-nowrap dataTable mt-4', thead: 'thead-light'};
        
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <div className="container-fluid">
                            <div className="app-content">
                                <section className="section">
                                    <div className="row">
                                        <Col lg='12'>
                                            <Tab.Container>
                                                <Row>
                                                    <Col lg='12'>
                                                        <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                            <div className="card-header flex-wrap"> 
                                                                <h3 className="fs-18 mb-4 header_title text-black"><Link to="/Dashboard" className="btn mr-2 btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link>  Medicine Master</h3> 
                                                                <Link to="/AddMedicine">
                                                                    <Button variant="secondary" className="float-right btn-primary" >
                                                                        <FaPlus className='mr-2' style={{verticalAlign: "text-top"}} />New Medicine
                                                                    </Button>
                                                                </Link>
                                                            </div>
                                                            <div className="card-body p-3">
                                                                <Row className="mb-3"> </Row>
                                                                <Row>
                                                                    <Col lg='12'>
                                                                        <CustomTable
                                                                            id="datatableMedicinelList"
                                                                            tableHeaders={header}
                                                                            tableBody={this.state.medicineData} 
                                                                            rowsPerPage={10}
                                                                            initialSort={{ prop: 'id', isAscending: true }}
                                                                            labels={customLabels}
                                                                            classes={classes}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <Loader show={this.state.loaderModal} />
                    </div>
                </div>
            </div>
        )
    }
}
